export default __webpack_public_path__ + "static/media/profit.f134711e.png";